import { render, staticRenderFns } from "./PriceDistribution.vue?vue&type=template&id=44cf6d76"
import script from "./PriceDistribution.vue?vue&type=script&lang=js"
export * from "./PriceDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports